import { toast } from "react-toastify";

export const TENANT_UNAVAILABLE_MESSAGE = "Tenant not configured for this SSO";

type ErrorWithResponse = {
  message?: string;
  data?: {
    message?: string;
    detail?: string;
    error?: string;
  };
  response?: {
    status?: number;
    data?: {
      message?: string;
      detail?: string;
      error?: string;
    };
  };
};

const getBackendErrorMessage = (error: ErrorWithResponse) => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    error?.response?.data?.error ||
    error?.data?.message ||
    error?.data?.detail ||
    error?.data?.error
  );
};

export const getErrorToastMessage = (
  error: unknown,
  fallbackMessage: string
) => {
  const typedError = error as ErrorWithResponse;

  return (
    getBackendErrorMessage(typedError) ||
    typedError?.message ||
    fallbackMessage
  );
};

export const isTenantUnavailableError = (error: unknown) => {
  const typedError = error as ErrorWithResponse;

  return (
    typedError?.response?.status === 403 &&
    getBackendErrorMessage(typedError) === TENANT_UNAVAILABLE_MESSAGE
  );
};

export const showErrorToast = (
  error: unknown,
  fallbackMessage: string
) => {
  toast.error(getErrorToastMessage(error, fallbackMessage));
};